import React from 'react';
import BillingsListFunctional from './components/billings-list-functional';
import './billings.scss';

const BillingsList = () => {
	return <BillingsListFunctional />;
};

export default BillingsList;
